import { useContext } from "react";
import { Link } from "react-router-dom";

import { Badge, Modal } from "flowbite-react";

import { IAppContextState, AppContext } from "../../../App";

import { QuranrtImageGallery } from "../../../components/image-gallery/quranrt-gallery";

export const QuranrtModalData = () => {
  const { quranrtModalState } = useContext<IAppContextState | any>(AppContext);
  const [isOpenQuranrtModal, setOpenQuranrtModal] = quranrtModalState;
  return (
    <Modal
      size={"5xl"}
      position={"top-center"}
      show={isOpenQuranrtModal}
      onClose={() => setOpenQuranrtModal(false)}
    >
      <Modal.Header>QuranRT - Quran Real Translation</Modal.Header>
      <Modal.Body>
        <div className="flex flex-wrap">
          <div className="md:w-[50%] w-full pe-2">
            <QuranrtImageGallery />
          </div>
          <div className="md:w-[50%] w-full ps-2 md:mt-0 mt-6 flex flex-col justify-between">
            <div>
              <h3 className="font-bold text-xl">
                Project name: <span className="text-yellow-500">QuranRT</span>
              </h3>
              <p className="mt-4 mb-2 text-md text-[15px]">Tech used:</p>
              <div className="flex">
                <Badge color="cyan" className="me-2 my-1">
                  React
                </Badge>
                <Badge color="blue" className="me-2 my-1">
                  Tailwind CSS
                </Badge>
                <Badge color="indigo" className="my-1">
                  Flowbite UI
                </Badge>
              </div>
              <div className="mt-5 mb-2 ">
                <p className="font-semibold">Description:</p>
                <div className="text-[15px]">
                  <p>
                    Quran-RT provides the Quran in Arabic with real Bangla and
                    English translations, along with bookmarking and advanced
                    search for easy navigation.
                  </p>
                  <ul className="list-disc mt-4 ms-5">
                    <li>
                      <strong>Multilingual Quran Reading</strong> – Read the
                      Quran in Arabic with accurate Bangla and English
                      translations.
                    </li>
                    <li>
                      <strong>Smart Navigation Tools</strong> – Includes
                      bookmarks, powerful search, and a rich sidebar for quick
                      surah access.
                    </li>
                    <li>
                      <strong>Modern, Responsive UI</strong> – Mobile-friendly
                      design with Dark Mode, built using React, TailwindCSS, and
                      Flowbite.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <Link
                target="_blank"
                rel="noreferrer"
                to="https://quranrt.org/"
                className="text-yellow-500 hover:text-yellow-600 hover:underline"
              >
                Go to website
              </Link>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
